<section class="mt-5">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="field">
            <label class="label has-text-black">{{ 'pages.login.email' | translate }}</label>
            <div class="control has-icons-left">
                <input class="input is-rounded" type="email" placeholder="e.g. alex@example.com" formControlName="email"
                    [class.is-danger]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
                <span class="icon is-small is-left">
                    <i class="ri-mail-line"></i>
                </span>
            </div>
            @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
            <p class="help is-danger">
                {{ 'pages.login.invalidEmail' | translate }}
            </p>
            }
        </div>

        <div class="field mt-4">
            <label class="label has-text-black">
                {{ 'pages.login.password' | translate }}
            </label>
            <div class="control has-icons-left">
                <input class="input is-rounded" type="password" placeholder="********" formControlName="password"
                    [class.is-danger]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                <span class="icon is-small is-left">
                    <i class="ri-lock-line"></i>
                </span>
            </div>
            @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
            <p class="help is-danger">
                {{ 'pages.login.passwordRequired' | translate }}
            </p>
            }
        </div>

        @if (errorMessage()) {
        <div class="notification is-danger is-light">
            {{ errorMessage() }}
        </div>
        }

        <div class="field mt-5">
            <div class="control">
                <button class="button is-primary is-rounded is-fullwidth" [class.is-loading]="isInSubmit()"
                    [disabled]="loginForm.invalid || isInSubmit()">{{ 'pages.login.login' | translate }}</button>
            </div>
        </div>
    </form>
</section>